import {useAppSelector} from "../../../redux/hooks";
import { mySongsFiltersStore } from "pages/songs-router/modules/my-songs-filters-store/mySongsFiltersStore";

export interface IFilterFeaturesLogic {
  isAvailable: boolean;
  isArrangementTypesAvailable: boolean;
}

export const useFilterFeaturesLogic = (): IFilterFeaturesLogic => {
  const isAvailable = useAppSelector(mySongsFiltersStore.isFeaturesAvailable);
  const isArrangementTypesAvailable = useAppSelector((): boolean =>
    mySongsFiltersStore.isFilterAvailable("arrangementType"));
  return {
    isAvailable,
    isArrangementTypesAvailable,
  };
}
